import { render, staticRenderFns } from "./mainlost.vue?vue&type=template&id=5694da9d&"
import script from "./mainlost.vue?vue&type=script&lang=js&"
export * from "./mainlost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports